import { render, staticRenderFns } from "./buy-zesa.vue?vue&type=template&id=3ce4feb2"
import script from "./buy-zesa.vue?vue&type=script&lang=js"
export * from "./buy-zesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports